import Box from '@eversports/klimt-primitives/legacy/Box'
import * as React from 'react'

import ManagerPromoSection from './ManagerPromoSection'

const SeoSection = () => {
  return (
    <Box component="aside" sx={{ contentVisibility: 'auto' }}>
      <ManagerPromoSection />
    </Box>
  )
}

export default React.memo(SeoSection)
